import { render, staticRenderFns } from "./NewTenantModal.vue?vue&type=template&id=5f7c22f2&"
import script from "./NewTenantModal.vue?vue&type=script&lang=js&"
export * from "./NewTenantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports